import {ApiUrls} from 'shared/config/model/urls';

import {useDispatch} from 'react-redux';

import {serverAPI} from 'features/server/api/serverAPI';
import {serverIncidentAPI} from 'features/server/api/serverIncidentAPI';
import {
    buildServerBatchOperationRequest,
    getServerBatchOperationsDefaults,
    getServerBatchResultTitle,
    ServerBatchOperationsFormValues,
} from 'features/server/lib/serverBatchHelper';
import {useMonitorBatchOperationsForm, IMonitorBatchOperationsFormState, isBatchDeleteAction} from 'entities/monitor';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

import {useServerSelection} from './useServerSelection';

interface IUseServerBatchOperationsFormParams {
    actionValue?: string,
    handleClose: () => void,
    onSuccess?: () => void,
}

export const useServerBatchOperationsForm = ({
    actionValue,
    handleClose,
    onSuccess,
}: IUseServerBatchOperationsFormParams): IMonitorBatchOperationsFormState<ServerBatchOperationsFormValues> => {
    const {selectedIds} = useServerSelection();
    const dispatch = useDispatch<TypedDispatch>();

    const invalidate = (action: string | undefined, ids: string[]) => {
        dispatch(serverAPI.util.invalidateTags([
            {type: 'Server', id: 'LIST'},
            ...(isBatchDeleteAction(action) ? [] : ids.map((uuid) => ({type: 'Server' as const, id: uuid}))),
        ]));

        if (action === 'stop' || action === 'delete') {
            dispatch(serverIncidentAPI.util.invalidateTags(['ServerIncident']));
        }

        dispatch(fetchMe());
    };

    return useMonitorBatchOperationsForm<ServerBatchOperationsFormValues>({
        actionValue,
        handleClose,
        onSuccess,
        selectedIds,
        getDefaultValues: getServerBatchOperationsDefaults,
        getUrl: (action) => ApiUrls.SERVERS_BATCH_ACTION(action ?? ''),
        buildRequest: buildServerBatchOperationRequest,
        invalidate,
        getResultTitle: getServerBatchResultTitle,
    });
};

export default useServerBatchOperationsForm;
